import styled from 'styled-components'

export const ShiftsContainer = styled.div`
  width: 100%;
  height: auto;
  padding-bottom: 1rem;
  
  .noData {
    padding: 0.625rem 0.75rem 0.5rem;
  }
  
  .hidden {
    display: none !important;
  }
  
  .loader {
    position: absolute;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.2);
  }
`

export const Shift = styled.div`
  background: white;
  border: 1px solid #E6E8EC;
  border-radius: 12px;
  padding: 0.875rem;
  margin: 0.5rem 0;
  box-shadow: 0 8px 18px rgba(11, 69, 152, 0.06);
  overflow: hidden;
  font-family: var(--fontMain, Poppins), sans-serif;
  
  &.recently-viewed {
    outline: 2px solid var(--brand-pink-light, #F7B2C4);
    outline-offset: 0;
    box-shadow: 0 0 0 2px rgba(247, 178, 196, 0.35), 0 8px 18px rgba(11, 69, 152, 0.06);
    transition: outline-color 0.3s ease, box-shadow 0.3s ease;
  }

  display: flex;
  flex-direction: column;
  align-items: stretch;
  
  .row {
    display: flex;
    flex-wrap: wrap;
  }
  
  .statuses {
    justify-content: flex-start;
    font-family: var(--fontMain, Poppins), sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 1rem;
    line-height: 22px;
    color: #05132E;
    gap: 0.25rem 0.75rem;
    min-width: 0;
  }
  .status:not(:first-child){
    padding-left: 0;
  }

  .cardFooter {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 0.375rem 0.75rem;
    margin-top: 0.625rem;
  }
  
  .postedOn {
    font-family: var(--fontMain, Poppins), sans-serif;
    font-size: 0.75rem;
    font-weight: 500;
    color: #9AA4B2;
    margin-left: auto;
    white-space: nowrap;
  }
  
  .status {
    font-family: var(--fontMain, Poppins), sans-serif;
    font-size: 0.925rem;
    line-height: 1.25rem;
    display: flex;
  }
  .instabookIcon { width: 24px; }
  .statusIcon { width: 18px; }

  .approxText {
    font-size: 0.8rem;
  }
  
  .half {
    width: 50%;
  }

  .quarter {
    width: 25%;
  }

  .infoGrid {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 0.5rem 1.25rem;
    margin-top: 0.375rem;
  }

  .infoGrid > div {
    flex: 0 1 auto;
    min-width: 0;
  }

  .rateRow {
    margin-top: 6px;
  }

  .softwareSection {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.25rem;
  }
  .softwareLabel {
    font-family: var(--fontMain, Poppins), sans-serif;
    font-size: 0.875rem;
    color: #3F4755;
  }
  .softwarePill {
    display: inline-flex;
    align-items: center;
    color: var(--primary-blue, #0B4598);
    background: rgba(11, 69, 152, 0.06);
    border: 1px solid rgba(11, 69, 152, 0.24);
    border-radius: 8px;
    padding: 4px 8px 4px 10px;
    border-left: 4px solid var(--primary-blue, #0B4598);
    font-family: var(--fontMain, Poppins), sans-serif;
    font-weight: 700;
    font-size: 0.875rem;
    line-height: 1;
  }
  /* removed pseudo-element stripe; using border-left instead to avoid absolute positioning */

  &.boosted {
    border: 3px solid rgba(11, 69, 152, 0.35) !important;
    border-bottom: 3px solid rgba(11, 69, 152, 0.35) !important; /* override base border-bottom */
    box-shadow: 0 2px 10px rgba(11, 69, 152, 0.08);
    border-radius: 12px;
  }

  /* Quick Apply */
  .ctaTopRight {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    order: 0;
    margin-top: 0;
    margin-left: auto;          /* stay pinned right even when header wraps */
    justify-content: flex-end;
    flex-shrink: 0;
    flex: 0 0 auto;
  }
  
  @media (min-width: 640px) {
    .ctaTopRight { margin-top: 4px; }
  }
  /* Ordering for desktop: Starting Soon before CTA */
  @media (min-width: 640px) {
    .ctaTopRight { order: 2; }
  }
  /* bottom-right CTA for mobile when boosted/featured */
  .ctaBottom {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
    margin-top: 10px;
  }
  .mobileOnly { display: flex; }
  .desktopOnly { display: none; }

  @media (min-width: 640px) {
    .mobileOnly { display: none; }
    .desktopOnly { display: inline-flex; }
  }
  }
  .quickApplyWrapper {
    margin-left: auto;
    display: flex;
    align-items: center;
  }
  .quickApplyBtn {
    background: var(--primary-blue, #0B4598);
    color: #fff;
    border: none;
    border-radius: 8px;
    padding: 8px 14px;
    font-family: var(--fontMain, Poppins), sans-serif;
    font-weight: 700;
    font-size: 0.875rem;
    line-height: 1;
    cursor: pointer;
    box-shadow: 0 2px 6px rgba(11,69,152,0.18);
  }
  .quickApplyBtn:disabled {
    opacity: 0.6;
    cursor: default;
  }

  /* Subtle blue border for boosted items in the regular list */
  &.boostedSubtle {
    border: 2px solid var(--primary-blue, #0B4598) !important;
    border-bottom: 2px solid var(--primary-blue, #0B4598) !important; /* override base border-bottom */
    border-radius: 8px;
  }
`

export const ShiftHeader = styled.div`
  font-family: var(--fontMain, Poppins), sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 1rem;
  line-height: 1.375rem;
  color: #05132E;
  flex: none;
  order: 0;
  flex-grow: 0;
  
  padding: 0.125rem 0 0.5rem;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: wrap;

  /* Align city and badges nicely on the same baseline */
  .col > .row {
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    width: auto;
    justify-content: flex-start;
  }
  .col { flex: 1 1 auto; min-width: 0; }
`

export const SmallBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  color: #05132E;
  font-family: var(--fontMain, Poppins), sans-serif;
  font-size: 1rem;
  line-height: 1.375rem;
  padding-top: 0.25rem;
  white-space: pre-wrap;

  .title {
    font-size: 0.875rem;
    line-height: 1.125rem;
    color: #3F4755;
  }
`

export const BoostBadge = styled.span`
  margin-left: 8px;
  color: var(--primary-blue, #0B4598);
  font-family: var(--fontMain, Poppins), sans-serif;
  font-weight: 600;
  background: #fff;
  border: 2px solid rgba(11,69,152,0.35);
  border-radius: 6px;
  padding: 2px 6px;
  display: inline-flex;
  align-items: center;
  gap: 6px;

  img {
    width: 32px;
    height: 32px;
    display: inline-block;
  }
`

export const StartingSoonBadge = styled.span`
  margin-left: 8px;
  color: var(--warning-dark, #7a5d00);
  font-family: var(--fontMain, Poppins), sans-serif;
  font-weight: 700;
  background: rgba(212,175,55,0.08);
  border: 1px solid rgba(212,175,55,0.3);
  border-radius: 6px;
  padding: 2px 6px;

  @media (max-width: 768px) {
    margin-left: 0;
  }
`
